export type LkPublicationStatus = 'draft' | 'published' | 'rejected';

export function lkStatusPillClass(s: LkPublicationStatus): string {
  if (s === 'draft') return 'pill p-draft';
  if (s === 'published') return 'pill p-com';
  return 'pill p-rej';
}

// Left chart (by category) — 12 pastel slots, ordered to maximise hue contrast between adjacent bars
// Hops ~150° across the colour wheel each step; cycle wrap (slate→amber) = 170°
export const LK_CATEGORY_LEFT_COLORS = [
  '#fbbf24',  // amber-400
  '#22d3ee',  // cyan-400
  '#e879f9',  // fuchsia-400
  '#fb923c',  // orange-400
  '#60a5fa',  // blue-400
  '#86efac',  // green-300 (mint)
  '#fb7185',  // rose-400
  '#a78bfa',  // violet-400
  '#fca5a5',  // red-300 (salmon)
  '#2dd4bf',  // teal-400
  '#f472b6',  // pink-400
  '#94a3b8',  // slate-400
];

// Right chart (by period) — every colour is ≥3 rows away from its left-chart position
// red/green-class colours (rose, mint, salmon) land at positions 9-12; teal at 7 (only valid slot)
export const LK_PERIOD_COLORS = [
  '#fb923c',  // orange-400    — left[3], gap=3
  '#94a3b8',  // slate-400     — left[11], gap=10
  '#f472b6',  // pink-400      — left[10], gap=8
  '#a78bfa',  // violet-400    — left[7], gap=4
  '#22d3ee',  // cyan-400      — left[1], gap=3
  '#fbbf24',  // amber-400     — left[0], gap=5
  '#2dd4bf',  // teal-400      — left[9], gap=3 (only slot satisfying gap ≥3 for teal)
  '#e879f9',  // fuchsia-400   — left[2], gap=5
  '#86efac',  // green-300     — left[5], gap=3 — green-class, back half
  '#fb7185',  // rose-400      — left[6], gap=3 — red-class, back half
  '#60a5fa',  // blue-400      — left[4], gap=6
  '#fca5a5',  // red-300       — left[8], gap=3 — red-class, back half
];
